export default __webpack_public_path__ + "static/media/2-rolling-on-the-floor-laughing_1f923.39f48892.png";